export default __webpack_public_path__ + "static/media/milestone 3800.c9d09080.svg";